var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-main',[_vm._v(" 欢迎回来，"+_vm._s(_vm.userInfo.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }